import { assertLayoutNodeExhaustive } from './layoutAssertNever';
import { walkLayoutStructureChildren } from './layoutStructureChildLists';
import type { LayoutNode } from './types';

/** User-visible copy declared in layout JSON (not schema prompts, not `qid` attributes). */
export function collectLayoutUserVisibleText(nodes: LayoutNode[]): string[] {
  const chunks: string[] = [];

  const pushLabelOverride = (node: { labelOverride?: string }): void => {
    const text = node.labelOverride?.trim();
    if (text) chunks.push(text);
  };

  const walk = (arr: LayoutNode[]) => {
    for (const node of arr) {
      switch (node.type) {
        case 'static':
        case 'text':
        case 'section-label':
          if (node.text.trim()) chunks.push(node.text);
          break;
        case 'display':
          if (node.label?.trim()) chunks.push(node.label);
          break;
        case 'table':
          if (node.rowHeader?.trim()) chunks.push(node.rowHeader);
          for (const header of node.colHeaders) {
            if (header.trim()) chunks.push(header);
          }
          for (const row of node.rows) {
            if (row.label.trim()) chunks.push(row.label);
          }
          break;
        case 'OASISRadio':
        case 'OASISYesNoCheckbox':
        case 'OASISSelect':
        case 'OASISText':
        case 'OASISDate':
        case 'OASISTime':
        case 'OASISNumber':
        case 'OASISMultiselect':
        case 'OASISMultiselectOption':
          pushLabelOverride(node);
          break;
        case 'card':
        case 'stack':
        case 'grid':
        case 'flex':
        case 'box':
        case 'indent':
        case 'field-row':
        case 'conditional':
        case 'disabled-when':
        case 'repeat':
        case 'divider':
        case 'sum':
        case 'radio-option':
          break;
        default:
          assertLayoutNodeExhaustive(node);
      }
      walkLayoutStructureChildren(node, walk);
    }
  };

  walk(nodes);
  return chunks;
}

export function layoutUserVisibleTextIncludes(
  chunks: readonly string[],
  literal: string
): boolean {
  if (!literal) return false;
  return chunks.some(chunk => chunk.includes(literal));
}
